import React from 'react';
import _ from "lodash";
import { 
  IoIosHammerIcon, 
  IoIosStatsIcon,
  IoIosListBoxIcon,
  IoIosCubeIcon, 
  IoIosPeopleIcon,
  IoIosMegaphoneIcon,
  IoIosFitnessIcon,
  IoIosCashIcon,
  IoIosCreateIcon,
  IoIosCallIcon,
  IoIosInformationCircleIcon,
  IoIosHelpCircleIcon,
  IoIosVideocamIcon,
  IoIosOptionsIcon,
  IoIosChatbubblesIcon,
  IoIosMdSync,
  FaFaVoteYea,
  FaFaIdCardAlt,
  IoIoMdWalk,
  IoIoLocate,
  IoIoAlertCircleSharp,
  AiAiFillAlert,
  RiRiServiceFill,
} from '../../config/icon.config';

const getCommunityFeatureList = () => {

const communityFeatureList = JSON.parse(localStorage.getItem('communityFeatureList'));
let communityType = _.isNil(localStorage.getItem('communityType')) || localStorage.getItem('communityType') === undefined ? 'CONDO' : localStorage.getItem('communityType')

// console.log("SideMenu_communityType: ", communityType);
// console.log("SideMenu_ISSUE_TRACKING: ", communityFeatureList.filter(item =>item.featureEnum ==='ISSUE_TRACKING').map(ele=>ele.isEnable)[0])
// console.log("SideMenu_ISSUE_TRACKING_isEnable", communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='ISSUE_TRACKING').map(ele=>ele.isEnable)[0] : false && communityType ==="VILLAGE" ? false : true);

const options = [
    {
      key: '',
      label: 'sidebar.dashboardPage',
      leftIcon: <IoIosStatsIcon size={19} />,
      //leftIcon: 'ion-stats-bars',
      isEnable: true,
      isVisible: true,
    },
    {
      key: 'issuetracking',
      label: 'sidebar.issueTracking',
      leftIcon: <IoIosListBoxIcon size={19} />,
      //isEnable: true,
      isEnable: communityType === "VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='ISSUE_TRACKING').map(ele=>ele.isEnable)[0] : false && communityType ==="VILLAGE" ? false : true,
      isVisible: communityType === "VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='ISSUE_TRACKING').map(ele=>ele.isVisible)[0] : false && communityType ==="VILLAGE" ? false : true,
    },
    {
      key: 'parcel',
      label: 'sidebar.parcelPage',
      leftIcon: <IoIosCubeIcon size={19} />,
      //isEnable: true,
      isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PARCEL').map(ele=>ele.isEnable)[0]: false,
      isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PARCEL').map(ele=>ele.isVisible)[0]: false,
    },
    {
      key: 'directory',
      label: 'sidebar.directoryPage',
      leftIcon: <IoIosPeopleIcon size={19} />,
      //isEnable: true,
      isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='DIRECTORY').map(ele=>ele.isEnable)[0]: false,
      isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='DIRECTORY').map(ele=>ele.isVisible)[0]: false,

    },
    {
      key: 'announcement',
      label: 'sidebar.announcementPage',
      leftIcon: <IoIosMegaphoneIcon size={19} />,
      //isEnable: true,
      isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='ANNOUNCEMENT').map(ele=>ele.isEnable)[0] : false,
      isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='ANNOUNCEMENT').map(ele=>ele.isVisible)[0] : false,
    },
    {
      key: 'facilitybooking',
      label: 'sidebar.facilityBooking',
      leftIcon: <IoIosFitnessIcon size={19} />,
      //isEnable: true,
      isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='FACILITY_BOOKING').map(ele=>ele.isEnable)[0] : false,
      isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='FACILITY_BOOKING').map(ele=>ele.isVisible)[0] : false,
    },
    {
      key: 'billing',
      label: 'sidebar.billingPage',
      leftIcon: <IoIosCashIcon size={19} />,
      //isEnable: true,
      isEnable: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='BILLING').map(ele=>ele.isEnable)[0] : false,
      isVisible: communityType ==="VILLAGE" ? false : communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='BILLING').map(ele=>ele.isVisible)[0] : false,
    },
    {
      key: 'suggestion',
      label: 'sidebar.suggestion',
      leftIcon: <IoIosCreateIcon size={19} />,
      //isEnable: true,
      isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='SUGGESTION').map(ele=>ele.isEnable)[0] : false,
      isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='SUGGESTION').map(ele=>ele.isVisible)[0] : false,
    },
    {
      key: 'repair',
      label: 'sidebar.repairPage',
      leftIcon: <IoIosHammerIcon size={19} />,
      //isEnable: communityType ==="VILLAGE" ? false : true,
      isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='REPAIR_REQUEST').map(ele=>ele.isEnable)[0] : false,
      isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='REPAIR_REQUEST').map(ele=>ele.isVisible)[0] : false,
    },
    {
      key: 'chat',
      label: 'sidebar.chatPage',
      leftIcon: <IoIosChatbubblesIcon size={19} />,
      //isEnable: true,
      isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='CHAT_NITI').map(ele=>ele.isEnable)[0] : false,
      isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='CHAT_NITI').map(ele=>ele.isVisible)[0] : false,
    },
    {
      key: 'phonebook',
      label: 'sidebar.phonebookPage',
      leftIcon: <IoIosCallIcon size={19} />,
      //isEnable: false,
      isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PHONEBOOK').map(ele=>ele.isEnable)[0] : false,
      isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PHONEBOOK').map(ele=>ele.isVisible)[0] : false,
    },
    {
      key: 'regulation',
      label: 'sidebar.regulationPage',
      leftIcon: <IoIosInformationCircleIcon size={19} />,
      //isEnable: true,
      isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='COMMUNITY_RULES').map(ele=>ele.isEnable)[0] : false,
      isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='COMMUNITY_RULES').map(ele=>ele.isVisible)[0] : false,
    },
    {
      key: 'recycling',
      label: 'sidebar.recyclingPage',
      leftIcon: <IoIosMdSync size={19} />,
      isEnable: false,
      isVisible: false,
      // isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='RECYCLING').map(ele=>ele.isEnable)[0] : false,
      // isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='RECYCLING').map(ele=>ele.isVisible)[0] : false,
    },
    {
      key: 'agmmeeting',
      label: 'sidebar.agmMeetingPage',
      leftIcon: <FaFaVoteYea size={19} />,
      // isEnable: true,
      isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='AGM_MEETING').map(ele=>ele.isEnable)[0] : false,
      isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='AGM_MEETING').map(ele=>ele.isVisible)[0] : false,
    },
    {
      key: 'losservices',
      label: 'sidebar.losservicesPage',
      leftIcon: <RiRiServiceFill size={19} />,
      isEnable: true,
      isVisible: true
      // isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='LOS_SERVICES').map(ele=>ele.isEnable)[0] : false,
      // isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='LOS_SERVICES').map(ele=>ele.isVisible)[0] : false,
    },
    {
      key: 'vms',
      label: 'sidebar.vmsPage',
      leftIcon: <FaFaIdCardAlt size={19} />,
      //isEnable: true,
      isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='VMS_NITI').map(ele=>ele.isEnable)[0] : false,
      isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='VMS_NITI').map(ele=>ele.isVisible)[0] : false,
    },
    {
      key: 'patrol',
      label: 'sidebar.patrolPage',
      leftIcon: <IoIoLocate size={19} />,
      //isEnable: true,
      isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PATROL').map(ele=>ele.isEnable)[0] : false,
      isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='PATROL').map(ele=>ele.isVisible)[0] : false,
    },
    {
      key: 'incident',
      label: 'sidebar.incidentPage',
      leftIcon: <IoIoAlertCircleSharp size={19} />,
      // isEnable: true,
      // isVisible: true
      isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='INCIDENT_REPORT').map(ele=>ele.isEnable)[0] : false,
      isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='INCIDENT_REPORT').map(ele=>ele.isVisible)[0] : false,
    },
    {
      key: 'tutorial',
      label: 'sidebar.tutorial',
      leftIcon: <IoIosVideocamIcon size={19} />,
      //isEnable: true,
      isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='TUTORIAL').map(ele=>ele.isEnable)[0] : false,
      isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='TUTORIAL').map(ele=>ele.isVisible)[0] : false,
    },
    {
      key: 'settings',
      label: 'sidebar.settingsPage',
      leftIcon: <IoIosOptionsIcon size={19} />,
      //isEnable: true,
      isEnable: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='SETTING').map(ele=>ele.isEnable)[0] : false,
      isVisible: communityFeatureList !== null ? communityFeatureList.filter(item =>item.featureEnum ==='SETTING').map(ele=>ele.isVisible)[0] : false,
    },

  ]

  return options;

}

export default getCommunityFeatureList;
